import { Mail, Phone, MapPin, Instagram, Lock } from "lucide-react";
import { Link } from "react-router-dom";

const Footer = () => {
  const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  return (
    <footer data-testid="footer" className="bg-[#2C2A28] text-white/80 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid md:grid-cols-3 gap-10">
        <div>
          <div className="bg-black rounded-2xl p-4 inline-block">
            <img src="/brand/logo.png" alt="Escarg'Holala" data-testid="footer-logo" className="h-28 w-auto object-contain" />
          </div>
          <p className="mt-5 text-sm leading-relaxed text-white/60 max-w-xs">
            Élevage, transformation et vente d'escargots cuisinés artisanaux. Le terroir bourguignon,
            de la coquille à l'assiette.
          </p>
        </div>

        <div>
          <h4 className="font-heading text-xl text-white mb-4">Navigation</h4>
          <ul className="space-y-2 text-sm">
            {[["exploitation", "L'Exploitation"], ["produits", "Nos Produits"], ["visites", "Visites & Dégustations"], ["contact", "Contact"]].map(([id, label]) => (
              <li key={id}>
                <button data-testid={`footer-nav-${id}`} onClick={() => go(id)} className="hover:text-creme transition-colors">{label}</button>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-xl text-white mb-4">Nous contacter</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-center gap-3"><Phone size={16} className="text-creme" /> 06 62 12 51 92</li>
            <li className="flex items-center gap-3"><Mail size={16} className="text-creme" /> escargholala@gmail.com</li>
            <li className="flex items-start gap-3"><MapPin size={16} className="text-creme mt-0.5" /> 982 Rue Principale, 71460 Savianges, Bourgogne</li>
          </ul>
          <a
            href="https://www.instagram.com/escargholala_bourgogne"
            target="_blank"
            rel="noreferrer"
            data-testid="social-instagram"
            className="group mt-6 inline-flex items-center gap-3 rounded-full bg-gradient-to-tr from-[#F58529] via-[#DD2A7B] to-[#8134AF] px-5 py-3 text-white font-600 shadow-lg hover:-translate-y-0.5 transition-transform"
          >
            <Instagram size={22} className="transition-transform group-hover:scale-110" />
            <span className="text-sm">@escargholala_bourgogne</span>
          </a>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 lg:px-10 mt-12 pt-6 border-t border-white/10">
        <p className="text-xs text-white/40 text-center mb-4">L'abus d'alcool est dangereux pour la santé. À consommer avec modération.</p>
        <div className="text-xs text-white/40 flex flex-col sm:flex-row justify-between gap-2">
          <span>© {new Date().getFullYear()} Escarg'Holala — SIRET 823 942 404 00018 — Tous droits réservés.</span>
          <span>Exploitation familiale d'héliciculture · Depuis 2015</span>
        </div>
        <div className="text-center mt-4">
          <Link
            to="/admin"
            data-testid="footer-admin-link"
            className="inline-flex items-center gap-1.5 text-[11px] text-white/25 hover:text-white/60 transition-colors"
          >
            <Lock size={11} /> Espace privé
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
